module.exports = __webpack_public_path__ + "img/manufacture.691357c.jpg";